import { createSelector } from "reselect";

import type { LegCards } from "./get-leg-cards";

import { getFilteredLegCardIdsByExcludedSources } from "./get-filtered-leg-card-ids-by-excluded-sources";
import { getFilteredLegCardsNoExcludedSources } from "./get-filtered-leg-cards-no-excluded-sources";

export const getFilteredLegCards = createSelector(
  [
    getFilteredLegCardsNoExcludedSources,
    getFilteredLegCardIdsByExcludedSources
  ],
  (leg_cards_no_excluded_sources, leg_card_ids_with_excluded_sources) => {
    const leg_card_ids = Object.keys(leg_cards_no_excluded_sources);

    return leg_card_ids
      .filter(id => {
        // Remove leg cards containing a segment from an excluded source
        if (!leg_card_ids_with_excluded_sources.includes(id)) {
          return false;
        }

        return true;
      })
      .reduce((filtered_leg_cards, id) => {
        filtered_leg_cards[id] = [...(leg_cards_no_excluded_sources[id] ?? [])];
        return filtered_leg_cards;
      }, {} as LegCards);
  }
);

type FilteredLegCards = LegCards;
type ExcludedLegCards = LegCards;

export const getSeparatedFilteredLegCards = createSelector(
  [
    getFilteredLegCardsNoExcludedSources,
    getFilteredLegCardIdsByExcludedSources
  ],
  (leg_cards_no_excluded_sources, leg_card_ids_with_excluded_sources) => {
    const leg_card_ids = Object.keys(leg_cards_no_excluded_sources);

    return leg_card_ids.reduce(
      (separated_leg_cards, id) => {
        const [filtered_leg_cards, excluded_leg_cards] = separated_leg_cards;
        const leg_card = leg_cards_no_excluded_sources[id];

        // Add leg cards containing a segment from an excluded source to excluded_leg_cards
        if (!leg_card_ids_with_excluded_sources.includes(id)) {
          excluded_leg_cards[id] = [...(leg_card ?? [])];
          // Place remaining leg cards in filtered_leg_cards
        } else {
          filtered_leg_cards[id] = [...(leg_card ?? [])];
        }
        return separated_leg_cards;
      },
      [{}, {}] as [FilteredLegCards, ExcludedLegCards]
    );
  }
);
